// 일시(date) 변환
export const formDate = (d) => {
  const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
  const date = new Date(d);
  return date.toLocaleDateString('ko-KR', options).replace(/(\d+)\D(\d+)\D(\d+)\D(\d+)\D(\d+)/, '$1.$2.$3 $4:$5:$6');
};

export const CARD_TYPE = ( cardCode ) => {
  const cardNames = {
    "01": "하나카드",
    "02": "우리카드",
    "03": "롯데카드",
    "04": "현대카드",
    "06": "국민카드",
    "11": "비씨카드",
    "12": "삼성카드",
    "14": "신한카드(구.LG카드 포함)",
    "21": "글로벌 VISA",
    "22": "글로벌 MASTER",
    "23": "글로벌 JCB",
    "24": "글로벌 아멕스",
    "25": "글로벌 다이너스",
    "26": "중국은련카드",
    "32": "광주카드",
    "33": "전북카드",
    "34": "하나SK카드",
    "35": "산업카드",
    "38": "우리BC카드 (44 사용 시 변경필요)",
    "41": "NH카드",
    "43": "씨티카드",
    "48": "신협체크카드",
    "51": "수협카드",
    "52": "제주카드",
    "54": "MG새마을금고체크",
    "55": "케이뱅크카드",
    "56": "카카오뱅크",
    "71": "우체국체크",
    "95": "저축은행체크"
  };

  return cardNames[cardCode] || "카드사를 찾을 수 없습니다.";
}